import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/language';
import { getStrLang } from '../../Translate';
import { getAceiteTermos, postLpCC } from '../../../api/fastcoinService';
import Loading from '../../../assets/loading.gif';
import toast, { Toaster } from 'react-hot-toast';
import { getURLBackToPanel } from '../../../context/brokersUrl';
const LPDC = (props) => {

    const { translate, lang, orderFromDeposit} = useLanguage();

    const country = sessionStorage.getItem("country").toLocaleLowerCase();


    const [loadingInfo, setLoadingInfo] = useState(false);
    const [card_holder_name, setCardHolderName] = useState("")
    const [card_number, setCardNumber] = useState("")
    const [cvv_number, setCvvNumber] = useState("")
    const [expire_date, setExpireDate] = useState("")


    useEffect(() => {
        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    if (res !== undefined) {
                        props.setShowTermos(false);
                    } else {
                        props.setShowTermos(true);
                    }
                    translate();
                })
                .catch(err => {
                    if (err.error.includes("Could not find")) {
                        console.log(err);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                    props.setShowTermos(true);
                })
        }
        if (orderFromDeposit !== "") {
            validarTermos();
        }


    }, []);


    useEffect(() => {
        translate();
        // if (country === "mx" || country === "ar") {
        //     setIsVirtual(true)
        // }
    }, [translate, country]);

    const callLP = (e) => {
        e.preventDefault();
        setLoadingInfo(true);
        postLpCC(sessionStorage.getItem("order_no"),"DebitCard", {
            "name":card_holder_name,
            "number":card_number,
            "cvv":cvv_number,
            "expirationMonth":expire_date.split("/")[0],
            "expirationYear":expire_date.split("/")[1],
        }).then(res => {
                if (res !== undefined) {
                    setLoadingInfo(false)
                    if(res.redirectUrl){
                        window.location=res.redirectUrl;
                    }else{
                        window.location.replace(getURLBackToPanel());
                    }
                } else {

                }
            })
            .catch(err => {
                if (err.response?.data?.error === "invalid_bin") {
                    toast.error(getStrLang(lang.nameLang, "invalid_bin"))
                }else if (err.response?.data?.error === "invalid_bin") {
                    toast.error(getStrLang(lang.nameLang, "invalid_card_type"))
                }else{
                    toast.error(err.response?.data?.error)
                }
                console.log(err.toString());
            }).finally(() => {
                setLoadingInfo(false);
                translate();
            });
    }

    const handleExpiryChange = (event) => {
        let input = event.target.value;
        input = input.replace(/[^0-9]/g, "");
        if (input.length > 7) {
            input = input.substr(0, 7);
        }
        if (input.length > 2) {
            input = input.substr(0, 2) + "/" + input.substr(2);
            const month = parseInt(input.substr(0, 2));
            if (month > 12) {
                input = "12/" + input.substr(3);
            }
        }
        setExpireDate(input);
    };
    const handleCvvChange = (event) => {
        let input = event.target.value;
        input = input.replace(/[^0-9]/g, "");
        if (input.length > 4) {
            input = input.substr(0, 4);
        }
        setCvvNumber(input);
    };

    return (
        <>
            <Toaster
                toastOptions={{
                    className: '',
                    style: {
                        border: '1px solid #0d4fb8',
                        color: '#0d4fb8',
                        padding: '12px',
                        top: '300px',
                        //  position: 'relative',
                    },
                }}
            />
            {loadingInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}
            {!loadingInfo && <div style={{ height: '100%' }}>
                <div className='row'>
                    <div className='col-md-12 d-flex justify-content-center'>
                        <form onSubmit={callLP} style={{ minWidth: "70%" }}>
                            <div className='form-group'>
                                <label htmlFor="card_holder_name">{getStrLang(lang.nameLang, "card_holder_name")}</label>
                                <input type="text" className='form-control' id="card_holder_name" name="card_holder_name" value={card_holder_name}
                                    placeholder={getStrLang(lang.nameLang, "enter_holder_name")} onChange={(e) => setCardHolderName(e.target.value)} required />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="card_number">{getStrLang(lang.nameLang, "card_number")}</label>
                                <input type="text" className='form-control' id="card_number" name="card_number"
                                    placeholder={getStrLang(lang.nameLang, "enter_card_number")} value={card_number} onChange={(e) => setCardNumber(e.target.value)} required />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="cvv_number">{getStrLang(lang.nameLang, "cvv_number")}</label>
                                <input type="text" className='form-control' id="cvv_number" name="cvv_number" placeholder="123" value={cvv_number} onChange={handleCvvChange} required />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="expire_date">{getStrLang(lang.nameLang, "expire_date")}</label>
                                <input type="text" className='form-control' id="expire_date" name="expire_date" value={expire_date} onChange={handleExpiryChange}
                                    required
                                    placeholder="MM/YYYY"
                                    minLength="7"
                                    maxLength="7"
                                    autoComplete="cc-exp" />
                            </div>

                            <button type='submit' className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "pay")}</button>
                        </form>
                    </div>
                </div>

            </div>}

        </>)
}

export default LPDC;